import Stars from "./Stars";
import Grid from "./Grid";
import Calendar from "./Calendar";

new Stars();
new Grid();
new Calendar();